import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const MessageModal = ({ showModal, handleCloseModal, modalBody }) => {
  return (
    <>
      <Modal show={showModal} onHide={() => handleCloseModal()}>
        <Modal.Header closeButton>
          <Modal.Title>Concurso</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{__html: modalBody}} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MessageModal;